<template>
  <card
    class="card-stats"
    :show-footer-line="true"
    :bodyClasses="{ 'pb-1': margin }"
  >
    <div class="row mb-2" v-if="iconInTop">
      <div class="col-12 text-center">
        <div
          class="icon icon-shape text-white rounded-circle shadow"
          :class="[`bg-${type}`, iconClasses]"
        >
          <i :class="icon"></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <slot>
          <h5
            :class="[
              margin ? 'mb-3' : 'mb-0',
              'card-title text-uppercase text-muted',
            ]"
            v-if="title"
          >
            {{ title }}
          </h5>
          <span class="h2 font-weight-bold mb-0" v-if="subTitle">{{
            subTitle
          }}</span>
        </slot>
      </div>

      <div class="col-auto" v-if="!iconInTop && ($slots.icon || icon)">
        <slot name="icon">
          <div
            class="icon icon-shape text-white rounded-circle shadow"
            :class="[`bg-${type}`, iconClasses]"
          >
            <i :class="icon"></i>
          </div>
        </slot>
      </div>
    </div>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer"> </slot>
    </p>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    icon: String,
    title: String,
    subTitle: String,
    iconClasses: [String, Array],
    margin: {
      type: Boolean,
      default: false,
    },
    iconInTop: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style></style>
